"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ImageView = void 0;
var react_1 = __importStar(require("react"));
var ImagePreview_1 = __importDefault(require("./ImagePreview/ImagePreview"));
var Context_1 = require("./Context");
var types_1 = require("./types");
var PanelContainer_1 = require("./PanelContainer");
var ImageViews;
(function (ImageViews) {
    ImageViews["Product"] = "product";
    ImageViews["PrintArea"] = "print-area";
})(ImageViews || (ImageViews = {}));
var baseUrl = "https://storage.googleapis.com/icstorage/";
var maskUrl = "https://storage.googleapis.com/icstorage/test/PT_Freya%20Black_75x100.png";
var matboardUrl = "https://storage.googleapis.com/icstorage/test/PT_Matboard_75x100.png";
exports.ImageView = react_1.default.forwardRef(function (props, ref) {
    var artwork = props.artwork, maskUrl = props.maskUrl, matboardUrl = props.matboardUrl, productDims = props.productDims, stretchDims = props.stretchDims, artworkPanel = props.artworkPanel, 
    // refHandleExport
    onResolutionWarning = props.onResolutionWarning, rotation = props.rotation, canvasTextsProps = props.canvasTexts, signatureProps = props.signature, outerArtworkProps = props.outerArtworkProps, paddings = props.paddings, isCanvass = props.isCanvass, isMaskOnFrame = props.isMaskOnFrame;
    var _a = react_1.default.useState(true), hideFrame = _a[0], setHideFrame = _a[1];
    var ctx = react_1.default.useContext(Context_1.GlobalContext);
    var canvasTexts = ctx.canvasTexts, handleSelectedText = ctx.handleSelectedText, handleChangeText = ctx.handleChangeText, handleScaling = ctx.handleScaling, handleSetSelectedPanel = ctx.handleSetSelectedPanel, handlePositionText = ctx.handlePositionText, selectedPanel = ctx.selectedPanel, signature = ctx.signature, artworkRotation = ctx.artworkRotation, scalePercent = ctx.scalePercent, setCanvasTexts = ctx.setCanvasTexts, setSignature = ctx.setSignature, dpi = ctx.dpi, setDPI = ctx.setDPI;
    react_1.useEffect(function () {
        if (artworkPanel === "signature") {
            handleSetSelectedPanel(types_1.PanelNames.Signature);
        }
        setCanvasTexts(canvasTextsProps !== null && canvasTextsProps !== void 0 ? canvasTextsProps : []);
        setSignature(signatureProps !== null && signatureProps !== void 0 ? signatureProps : {});
    }, []);
    var handleFrameVisibility = function (v) {
        var _a;
        (_a = ref === null || ref === void 0 ? void 0 : ref.current) === null || _a === void 0 ? void 0 : _a.handleHideFrame(v);
        setHideFrame(v);
    };
    return (react_1.default.createElement("div", null,
        react_1.default.createElement("div", { className: "d-flex align-items-center justify-content-between py-2 " },
            react_1.default.createElement(PanelContainer_1.PanelContainer, { artwork: artwork }),
            react_1.default.createElement("div", { className: "text-center" },
                react_1.default.createElement("button", { 
                    // onClick={() => setHideFrame(false)}
                    onClick: function () { return handleFrameVisibility(false); }, className: "btn mx-2 btn-sm btn-" + (hideFrame === false ? "primary-alt" : "primary") }, "Product Sample"),
                react_1.default.createElement("button", { onClick: function () { return handleFrameVisibility(true); }, className: "btn btn-sm btn-" + (hideFrame === true ? "primary-alt" : "primary") }, "Print Area"))),
        react_1.default.createElement("div", { style: { backgroundColor: "white", minHeight: 400 } },
            react_1.default.createElement(ImagePreview_1.default, { ref: ref, 
                // hideFrame={hideFrame}
                // onHideFrame={(v) => setHideFrame(v)}
                hideMatboard: false, artworkUrl: artwork, matboardUrl: matboardUrl, maskUrl: maskUrl, productDims: productDims, stretchDims: stretchDims, scalePercent: scalePercent, canvasTexts: canvasTexts, outerArtworkProps: outerArtworkProps, onCanvasTexts: setCanvasTexts, signature: signature, paddings: {
                    x: (paddings === null || paddings === void 0 ? void 0 : paddings.x) || 0,
                    y: (paddings === null || paddings === void 0 ? void 0 : paddings.y) || 0
                }, onSignature: setSignature, artworkRotation: artworkRotation !== null && artworkRotation !== void 0 ? artworkRotation : outerArtworkProps === null || outerArtworkProps === void 0 ? void 0 : outerArtworkProps.rotation, selectedPanel: selectedPanel, onSelectedText: handleSelectedText, onChangeText: handleChangeText, onScaling: handleScaling, onResolutionWarning: onResolutionWarning, rotation: rotation, dpi: dpi, onDPI: setDPI, onPositionText: handlePositionText, isCanvass: isCanvass, isMaskOnFrame: isMaskOnFrame })),
        react_1.default.createElement("p", { className: "text-danger  mt-2 py-2 pl-2", style: {
                paddingRight: "335px",
                backgroundColor: "var(--white)"
            } }, "IMPORTANT! Everything in this area will be printed - including unwanted white space. Extend your image to slightly outside the red dotted line for a perfect print.")));
});
